import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import type { PlantingGeometry, PlantType } from "../types";

dayjs.extend(utc);
dayjs.extend(timezone);

export const TZ = "Asia/Tashkent";

export function formatDateTime(date: string | undefined | null): string {
	if (!date) {
		return "—";
	}
	return dayjs.utc(date).tz(TZ).format("DD.MM.YYYY HH:mm");
}

/** Color per plant type for map + legend */
export const PLANT_TYPE_COLORS: Record<PlantType, string> = {
	DARAXT: "#22c55e", // green
	"KO'CHAT": "#14b8a6", // teal
	GUL: "#ec4899", // pink
};

export const FALLBACK_PLANT_COLOR = "#6b7280";

export const PLANT_TYPE_LABELS: Record<PlantType, string> = {
	DARAXT: "Daraxt",
	"KO'CHAT": "Ko'chat",
	GUL: "Gul",
};

export function plantTypeColor(type?: PlantType): string {
	return type ? (PLANT_TYPE_COLORS[type] ?? FALLBACK_PLANT_COLOR) : FALLBACK_PLANT_COLOR;
}

export function plantTypeLabel(type?: PlantType): string {
	return type ? (PLANT_TYPE_LABELS[type] ?? type) : "—";
}

/** Uzbek label for a geometry's GeoJSON type */
export function geometryTypeLabel(type: PlantingGeometry["type"]): string {
	return type === "Point" || type === "MultiPoint" ? "Nuqta" : "Poligon";
}
